import Head from 'next/head'
import { useRouter } from 'next/router'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { DEFAULT_THUMBNAIL, OG_IMAGE_HEIGHT, SITE_NAME } from 'libs/constants'
import { getUrlWithoutQueryParams } from 'libs/utils'
import { Outcome } from 'types/data'

export const Meta = () => {
  const { t } = useTranslation('@mc/next')
  const { asPath } = useRouter()
  const { outcome } = useStaticData<{ outcome: Outcome }>()

  const title = outcome?.name || t('outcomePage.meta.title')
  const description = outcome?.oneLiner || t('outcomePage.meta.description')

  return (
    <Head>
      <title>{title}</title>
      <meta content={getUrlWithoutQueryParams(asPath)} property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={description} name='description' />
      <meta content={t('outcomePage.meta.keywords')} name='keywords' />
      <meta content={title} property='og:title' />
      <meta content={description} property='og:description' />
      <meta content={DEFAULT_THUMBNAIL} property='og:image' />
      <meta content={OG_IMAGE_HEIGHT} property='og:image:height' />
    </Head>
  )
}
